<template>
  <span
    class="badge line-clamp-1 flex items-baseline"
    :class="badge_styles[status ?? '']?.class"
  >
    <i :class="badge_styles[status ?? '']?.ico"></i>
    {{ badge_styles[status ?? ""]?.text ?? "Không có thông tin" }}
  </span>
</template>

<script setup lang="ts">
const badge_styles: {
  [key: string]: { class: string; text: string; ico: string };
} = {
  pending: {
    class: "badge-warning",
    text: "Chờ xử lý",
    ico: "fa-solid fa-circle-pause",
  },
  "in-progress": {
    class: "badge-info",
    text: "Đang xử lý",
    ico: "fa-solid fa-clock",
  },
  complete: {
    class: "badge-success",
    text: "Hoàn tất",
    ico: "fa-solid fa-circle-check",
  },
  stop: {
    class: "badge-warning",
    text: "Đang dừng",
    ico: "fa-solid fa-circle-pause",
  },
  stopped: {
    class: "badge-error",
    text: "Đã dừng",
    ico: "fa-solid fa-stop",
  },
};

defineProps<{
  status?: string;
}>();
</script>
